<template>
  <div class="product-view">
    <v-row class="products">
      <v-card class="product">
        <router-link to="/">
          <img class="img" v-bind:src="item.picture" v-bind:alt="item.name" />
          <h6 class="productname">{{item.name | shorterDescription}}</h6>
          <p class="desc">{{item.description | shortDescription}}</p>
          <p class="description">₦{{item.price}}.00</p>
          <hr  class='spaced2'/>
          <v-card-actions>
            <b-button
              :loading="loading"
              @click="addItem"
              class="is-success is-light addd"
              label="ADD TO CART"
            ></b-button>
          </v-card-actions>
        </router-link>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      disabled: false,
      loading: false,
      isActive: false,
      isChecked: false
    };
  },
  props: ["item"],
  methods: {
    ...mapActions(["updateCart"]),
    addItem() {
      this.$buefy.toast.open({
        message: `Product successfully added to your cart`,
        type: "is-success",
        position: "is-top"
      });
      const order = {
        item: Object.assign({}, this.item),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    },
    mounted() {
      this.$fb.database
        .collection("Product")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.loading = true;
            let data = {
              name: doc.data().name,
              description: doc.data().description,
              price: doc.data().price,
              slug: doc.data().slug,
              picture: doc.data().picture,
              quantity: doc.data().quantity
            };
            this.products.push(data);
            this.loading = false;
          });
        });
    }
  },
  filters: {
    shortDescription(value) {
      if (value && value.length > 100) {
        return value.substring(0, 100) + "...";
      } else {
        return value;
      }
    },
    shorterDescription(value) {
      if (value && value.length > 30) {
        return value.substring(0, 25) + "...";
      } else {
        return value;
      }
    }
  }
};
</script>

<style>
.spaced{
  display: none
}
.spaced2{
  display: block
}
.addd {
  width: 100%;
}
.product-view {
  display: flex;
}
.products {
  justify-content: space-around;
}
.product {
  width: 300px;
  height: 500px;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  margin: 1em;
  overflow: hidden;
  justify-content: space-around;
}

.img {
  margin: 2em;
}
.img:hover {
  transform: scale(1.1);
}
.productname {
  color: green;
  margin-left: 1em;
}
.description {
  color: black;
  margin-top: 0.5em;
  margin-left: 1em;
}
.actions {
  display: flex;
}
.row {
  justify-content: space-evenly;
}
.add {
  width: 100%;
}
.desc {
  color: green;
  margin-left: 1em;
}
@media only screen and (max-width: 711px) {
  .product {
    width: 200px;
    height: 500px;
  }
  .spaced2{
    display: none
  }
  .spaced{
    display: block
  }
  .desc {
    display: none;
  }
  .addd {
    width: 100%;
  }
  .productname {
    margin-top: 0;
    font-size: 0.9em;
    text-transform: lowercase;
  }
  .store {
    margin-top: 2em;
    width: 100%;
  }
}
</style>
